import emrService from '@/apis/emr/service';
import NoDataYet from '@/components/NoDataYet';
import BaseTitleIcon from '@/components/PHR/BaseTitleIcon';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import BaseSpin from '@/components/bases/BaseSpin';
import CardHealthRecord from '@/screens/BodyScreen/components/CardHealthRecord';
import useBodyScreenStore from '@/screens/BodyScreen/store';
import useGlobalConfigs from '@/stores/globalConfigs';
import { usePhrStoreInContext } from '@/stores/phr';
import dayjs from 'dayjs';
import * as React from 'react';

export interface IListHealthRecordProps {}

const SectionListHealthRecord: React.FC<IListHealthRecordProps> = ({ ...props }) => {
  const uid = usePhrStoreInContext((s) => s.uid);
  const keyBody = useBodyScreenStore((s) => s.keyBody);
  const setRefetchBody = useGlobalConfigs((s) => s.setRefetchBody);
  const keyBodyCondition =
    keyBody === 'other'
      ? { $or: [{ 'data.icd.data.body': keyBody }, { 'data.icd.data.body': { $exists: false } }] }
      : { 'data.icd.data.body': keyBody };

  const {
    data: res,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
  } = emrService.useGetEmrInfinite({
    type: 'healthRecord',
    uid,
    filter: keyBody ? JSON.stringify(keyBodyCondition) : undefined,
    limit: 10,
  });

  React.useEffect(() => {
    setRefetchBody(refetch);
  }, [refetch, setRefetchBody]);

  let data: IEMRData[] = [];

  res?.pages?.forEach((d: any) => {
    const newData: IEMRData[] = d.data || [];
    data = [...data, ...newData];
  });

  const groupHrByMonth: Record<string, IEMRData[]> =
    data?.reduce((d: any, e) => {
      const day = dayjs(e.date);
      d[day.format('MM/YYYY')] = d[day.format('MM/YYYY')] ? [...d[day.format('MM/YYYY')], e] : [e];
      return d;
    }, {}) || {};

  let count = 0;

  return (
    <div className="rounded-lg bg-gray-1 shadow overflow-auto p-4 h-full flex flex-col">
      <div className="w-full">
        <BaseTitleIcon
          type="h1-yellow"
          src="/icons/Line/File.svg"
          title="HỒ SƠ BỆNH ÁN"
          sub={
            <div className="font-normal flex items-center bg-gray-100 rounded-xl pr-1">
              <BaseIconSvg
                src="/icons/Regular/Warning - icon.svg"
                className="wh-[16px] text-white bg-red-500 rounded-xl p-0.5 mr-1 flex-none"
              />
              <div
                onClick={() => {
                  fetchNextPage({});
                }}
              >
                Chú giải: Bệnh án cần chú ý
              </div>
            </div>
          }
        />
        <div className="h-[1px] w-full mt-4 mb-4 bg-gray-200" />
      </div>

      <div className="flex-grow relative w-full h-[500px]">
        {/* Bắt cho tôi sự kiện scroll đến cuối trang vào thẻ này */}

        <div
          className="absolute top-0 left-0 bottom-0 right-0 overflow-auto"
          onScroll={(e) => {
            const element: any = e.target;
            const { scrollTop, clientHeight, scrollHeight } = element;

            if (scrollTop + clientHeight >= scrollHeight - 50) {
              !isFetchingNextPage && fetchNextPage();
            }
          }}
        >
          {Object.values(groupHrByMonth).length ? (
            Object.values(groupHrByMonth)?.map((emrs, i) => {
              const day = dayjs(emrs[0].date);
              return (
                <div key={i.toString()} className="flex mb-4">
                  {/*  ngày */}
                  <div className="w-1/6 p-2">
                    <div className="w-full">
                      <BaseIconSvg
                        src="/icons/Line/Calendar.svg"
                        className="wh-[32px] text-white rounded-xl p-2 bg-mint-5"
                      />
                    </div>
                    <div className="w-full flex flex-wrap items-center mt-2 gap-1">
                      <span className="font-bold">{day.format('MM')}</span>
                      <span className=" text-sm">{day.format('YYYY')}</span>
                    </div>
                  </div>
                  <div className="w-5/6 flex flex-wrap border-b pb-2">
                    {emrs?.map((d, i: number) => {
                      count++;
                      return (
                        <div key={i.toString()} className={`p-2 ${count <= 2 ? 'w-full' : 'w-1/2'}`}>
                          <CardHealthRecord healthRecord={d} />
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })
          ) : (
            <NoDataYet />
          )}
        </div>
        {isFetchingNextPage && (
          <div className="absolute top-0 left-0 bottom-0 right-0 bg-gray-1 bg-opacity-80 flex justify-center items-center">
            <BaseSpin />
          </div>
        )}
      </div>
    </div>
  );
};
export default SectionListHealthRecord;
